export default class NameOfHelper {
    public constructor() {}

    // obj(expression: any): string|undefined {
    //     return Object.keys(this.object).find((prop) => prop === expression);
    // }
    public static obj(propFunction: Function): any {
        // @ts-ignore
        return /\.([^\.;]+);?\s*\}$/.exec(propFunction.toString())[1];
    }
}
